import React from 'react';
import _get from 'lodash/get';
import {
  AccessComponentEnum,
  AccessLevelEnum,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import QuestionTypeChip from 'components/FormTemplateBuilder/QuestionTypeChip/QuestionTypeChip';
import QuestionFieldsPreview from 'components/FormTemplateBuilder/QuestionFieldsPreview/QuestionFieldsPreview';
import FormTemplateBuilderQuestionView from 'components/FormTemplateBuilder/FormTemplateBuilderQuestionView/FormTemplateBuilderQuestionView';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import { Values } from '@lib/interfaces/form';
import getVisibleQuestions from './utils/getVisibleQuestions';
import styles from './FormTemplateBuilderView.module.scss';

interface Props {
  formTemplateVersionData: Values;
}

export default function FormTemplateBuilderQuestionsView(props: Props) {
  const { formTemplateVersionData } = props;
  const { getUserAccessByCompany, isFullAdmin }: ContextProps =
    useOutletContext();
  const isViewLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  const questions = getVisibleQuestions({
    formTemplateVersionData,
    isViewLocked,
    isFullAdmin,
  });

  return (
    questions?.length > 0 &&
    questions.map((question) => {
      const kind = _get(question, [
        FormTemplateFieldNames.Fields,
        0,
        FormTemplateFieldNames.Kind,
      ]);
      return (
        <WhiteBox className={styles.questionBlock} key={question.position}>
          <QuestionTypeChip
            kind={kind}
            className={
              kind === FormTemplateQuestionFieldsKindEnum.ImportantNotice
                ? styles.questionTypeChip
                : undefined
            }
          />
          <FormTemplateBuilderQuestionView value={question}>
            <QuestionFieldsPreview fields={question.fields} value={question} />
          </FormTemplateBuilderQuestionView>
        </WhiteBox>
      );
    })
  );
}
